import {actions as A} from '../../constants/actions';
import {sessionStorageKeys as S} from '../../constants/sessionStorageKeys';
import {setSessionStorageItem} from '../../utils/sessionStorage';

const setLocale = (current) => {
    setSessionStorageItem(S.LOCALE, current);

    return (dispatch) => {
        dispatch({
            type: A.SET_LOCALE,
            payload: {current}
        });
    }
};

export {setLocale}
